import { CheckCircle2, KeyRound, LoaderCircle, XCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { completeMCPOAuth } from '../../services/mcp-server';

const STATES = {
  loading: {
    icon: LoaderCircle,
    title: 'Concluindo autorização',
    message: 'Validando o vínculo seguro com o MCP de atendimento…',
  },
  success: {
    icon: CheckCircle2,
    title: 'MCP autorizado',
    message: 'A conexão foi salva. Esta janela será fechada automaticamente.',
  },
  error: {
    icon: XCircle,
    title: 'Não foi possível autorizar',
    message: 'Feche esta janela e inicie a autorização novamente pelo Verboo Lab.',
  },
};

function readCallbackRequest() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  const providerError = params.get('error_description') || params.get('error');
  const error = providerError || (!code || !state ? 'O provedor não retornou um código OAuth válido.' : '');
  return { code, state, error };
}

export default function MCPOAuthCallback() {
  const [request] = useState(readCallbackRequest);
  const [status, setStatus] = useState(request.error ? 'error' : 'loading');
  const [detail, setDetail] = useState(request.error);

  useEffect(() => {
    // OAuth codes and state must not remain in browser history, telemetry or
    // referrers after the callback bundle has started.
    window.history.replaceState({}, document.title, window.location.pathname);

    if (request.error || !request.code || !request.state) return;

    completeMCPOAuth({ code: request.code, state: request.state })
      .then(() => {
        setStatus('success');
        window.opener?.postMessage(
          { type: 'verboo:mcp-oauth', status: 'success' },
          window.location.origin,
        );
        window.setTimeout(() => window.close(), 1200);
      })
      .catch((error) => {
        setStatus('error');
        setDetail(error?.data?.message || error?.data?.error || 'A autorização expirou ou não pertence a este usuário.');
        window.opener?.postMessage(
          { type: 'verboo:mcp-oauth', status: 'error' },
          window.location.origin,
        );
      });
  }, [request]);

  const content = STATES[status];
  const Icon = content.icon;

  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--dash-bg)] px-5 text-[var(--dash-text)]">
      <section
        className="flex w-full max-w-md flex-col items-center gap-5 rounded-2xl px-8 py-10 text-center shadow-xl"
        style={{ background: 'var(--dash-surface)', border: '1px solid var(--dash-border)' }}
      >
        <div
          className="flex h-14 w-14 items-center justify-center rounded-2xl"
          style={{ background: 'var(--dash-primary-soft)', color: status === 'error' ? 'var(--dash-danger)' : 'var(--dash-primary)' }}
        >
          <Icon size={27} className={status === 'loading' ? 'animate-spin' : ''} />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-lg font-semibold">{content.title}</h1>
          <p className="text-sm leading-relaxed text-[var(--dash-text-muted)]">{content.message}</p>
          {detail && <p className="mt-1 text-xs text-[var(--dash-danger)]">{detail}</p>}
        </div>
        <div className="flex items-center gap-2 rounded-xl px-3 py-2 text-[11px] text-[var(--dash-text-muted)]" style={{ background: 'var(--dash-surface-subtle)' }}>
          <KeyRound size={13} />
          O código é descartável e vinculado ao seu login no Lab.
        </div>
      </section>
    </main>
  );
}
